import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectBaseState } from './project-base.model';
import { FEATURE_NAME } from './project-base.constant';

export const selectProjectBaseState = createFeatureSelector<ProjectBaseState>(FEATURE_NAME);

export const selectProjectTags = createSelector(
  selectProjectBaseState,
  (state) => state.tags
);

export const selectRevealedProjectEnvContent = createSelector(
  selectProjectBaseState,
  (state) => state.revealedEnvContent
);

/**
 * Selects all registered WireGuard VPN public keys for an actual project.
 */
export const selectProjectVpnSettingsMap = (id: string) => createSelector(
  selectProjectBaseState,
  (state) => state.vpnSettingsMap[id]?.peers
);

/**
 * Selects L7 HTTP balancer configuration for a project.
 */
export const selectProjectL7Config = (projectId: string) => createSelector(
  selectProjectBaseState,
  (state) => state.l7ConfigMap?.[projectId]
);
